export class AwsEc2Resource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "volumes",
            "baseName": "volumes",
            "type": "Array<InventoryVolume>",
            "format": ""
        },
        {
            "name": "operatingSystem",
            "baseName": "operatingSystem",
            "type": "OperatingSystem",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEc2Resource.attributeTypeMap;
    }
    constructor() {
    }
}
